var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.477 2-4.5 8h-9l4.5-8z",
    opacity: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.975 10h9l-4.5-8h-9z",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.477 18 4.5-8-4.5-8-4.5 8z",
    opacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m11.52 30 4.5-8h9l-4.5 8z",
    opacity: 0.45
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m16.022 22h-9l4.5 8h9z",
    opacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m20.52 14-4.5 8 4.5 8 4.5-8z",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidity);
export default __webpack_public_path__ + "static/media/solidity.e8d827ad36ef876c4aaa94bf24a8f5b9.svg";
export { ForwardRef as ReactComponent };